//This component contitionally renders either a worker's jobsite card or a foreman's jobsite card based on the worker's role.
import React, { useState } from "react";
import WorkerJobsite from "./WorkerJobsite";
import ForemanJobsiteCard from "./ForemanJobsiteCard";
import { useSelector } from "react-redux";

const JobsiteCardContainer = ({ jobSite }) => {
  const [flipped, setFlipped] = useState(false);
  const { workerId } = useSelector((state) => state.workerAuth.workerUser);
  const isForeman = jobSite.foremen?.some(f => f.id === workerId);

  const handleFlip = () => setFlipped((prev) => !prev);

  return (
    <div className="relative w-full">
      {!flipped ? (
        <WorkerJobsite 
          jobSite={jobSite} 
          onImageClick={isForeman ? handleFlip : undefined} />
      ) : (
        <ForemanJobsiteCard 
          jobSite={jobSite}
          onBackClick={handleFlip} />
      )}
    </div>
  );
};

export default JobsiteCardContainer;
